import { useDispatch, useSelector } from "react-redux";
import { USER, USERALL, COMPANY, PROJECT, PROGRESS, PROGRESSALL } from "../../services/actions";
import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { Container, Box, Grid, Pagination } from "@mui/material";
import InfoCard2 from "../extra/InfoCard2";
import Form from "./TaskForm";
import ActionBar from "../extra/ActionBar";
import SearchBar from "../extra/SearchBar";
import XTable from "../extra/XTableAnother";
import { layouts } from "chart.js";
import MoreInfo from "../extra/MoreInfo";

export default function View() {
  let dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { project, site } = location.state || {};
  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const [view, setView] = React.useState(1); // Added state for view
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)

  let progressState = useSelector((state) => state?.progressState);
  let progressallState = useSelector((state) => state?.progressallState);
  let user = useSelector((state) => state?.loginState?.auth);

  const fetchTasks = (page = 0) => {
    const url = page === 0 ? `progress_list/${page}/?filter_by={"worksite_id":"${site.id}"}` : `progress_list/?page=${page}&filter_by={"worksite_id":"${site.id}"}`; // pass page number
    dispatch({ type: `${PROGRESSALL}_GET`, payload: url });
  };

  React.useEffect(() => {
    try {
      fetchTasks(0);
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    fetchTasks(page);
  }, [page]);

  React.useEffect(() => {
    if (progressState.success) {
      setOpen(false);
      fetchTasks(0)
    }
  }, [progressState?.data]);

  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `progress_list/0/?filter_by={"${key}__istartswith":"${value}","worksite_id":"${site.id}"}`;
    dispatch({ type: `${PROGRESSALL}_GET`, payload: query });
  };

  // Prepare data for XTable
  const tableHeadings = [
    "ID",
    "Image",
    "Task Name",
    "Site",
    "Project"
  ];
  const tableRows = progressallState?.data?.results?.map((user) => ({
    id: user.id, // Include ID to find the original data on edit
    image: user.avatar,
    task_name: user.task_name,
    site_name: user.site_name,
    project_name: user.project_name,
  }));

  const handleEdit = (data) => {
    data.deadline = data.deadline?.split("T")[0]
    setDefV(data);
    setOpen(true);

  };

  const handleDelete = (id) => {
    dispatch({ type: `${PROGRESS}_DELETE`, payload: id });
  };

  return (
    <>
      {open ? (
        <Box sx={{ p: 2 }}>
          <Form
            project={project}
            defaultValues={defV}
            title={`Project started @ ${project?.start_project_date.split("T")[0]}`}
            onSubmit={(data) => {
              data.worksite = site.id
              let ACTION = data.id ? `${PROGRESS}_PATCH` : `${PROGRESS}_POST`;
              dispatch({ type: ACTION, payload: data });
            }}
            back={() => {
              setOpen(false);
            }}
          />
        </Box>
      ) : (
        <Container maxWidth="false" className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
              if (type == "previous") {
                navigate("/sites/", {
                  state: {
                    project: project,
                    site: site
                  },
                });
              }
            }}
            hasPermission={user?.permissions?.includes("work_progs.add_workprogress")}
            label="Tasks"
            setOpen={(s) => {
              setDefV({}); // Reset default values
              setOpen(true);
            }}
            btnLabel="ADD TASK"
            btnPrevLabel="BACK"
          />
          <SearchBar bylist={["task_name"]} handleSearch={handleSearch} />
          {view === 1 && (
            <>
              <Grid container spacing={2}>
                {progressallState?.data?.results?.map((data) => {
                  data.image = user;
                  data.progress_value = `${data?.progress?.value || 0}%`
                  data.status = data?.progress?.value == 0 ? "To DO" : (data?.progress?.value == 100 ? "Done" : "Progress")
                  // data.project_count = data.projects?.length; // Added project count for display
                  return (
                    <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>
                      <InfoCard2
                        sx={{
                          height: 300, // Use the prop, or a default value
                        }}
                        type="user"
                        keys={[
                          "image",
                          "task_name",
                          "site_name",
                          "project_name",
                          "Progress",
                          "progress_value",
                          "Status",
                          "status",
                          "",
                          "live_camera_count",
                          "last_name",
                        ]}
                        data={data}
                        onClick={() => {
                          //navigate("/timelapse-preview/", {})
                        }}
                        onAction={(action, data) => {
                          if (action == "Edit") {
                            handleEdit(data); // Call the shared edit handler
                          } else if (action == "Delete") {
                            handleDelete(data.id); // Call the shared delete handler
                          } else if (action == "More") {
                            setDefV(data);
                            setView(3);
                          }
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Pagination
                  count={Math.ceil(progressallState?.data?.count / pageSize)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </Box>
            </>
          )}

          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={handleEdit} // Use the shared handler
              onDelete={handleDelete} // Use the shared handler
            />
          )}
          {view === 3 && (
            <MoreInfo
              data={{
                ...defV,
                is_active: defV.is_active ? "Yes" : "No",
                // verify: defV.verify ? "Yes" : "No",
              }}
              skip={[
                "avatar",
                "address",
                "refresh_token",
                "token",
                "is_social_login",
                "shared_key",
                "whatsapp_number"

              ]}
              group={["first_name", "last_name", "username", "created_at"]}
              // icons={{ access_loation: <BsCopy /> }}
              // css={{ access_location: { color: '#1976d2' } }}
              onClose={() => {
                setView(1);
              }}
            />
          )}
        </Container>
      )}
    </>
  );
}
